import { useActiveSalesCampaignCodes } from "~/features/salesCampaign/hooks/useActiveSalesCampaignCodes";
import { useDispatch, useSelector } from "react-redux";
import { type RootState } from "~/app/store";
import { toggleCampaignOnlyResultsThunk } from "~/features/search/redux/actions";

import { SaleTag } from "~/domains/salesCampaign/components/SaleTag/SaleTag";
import { useTranslation } from "react-i18next";
import { selectIsFilterActive } from "~/features/search/redux/searchSelectors";
import { styled } from "~/common/mui";
import { ICON_MARGIN } from "~/styles/cssConstants";
import { Switch } from "~/common/components/Switch/Switch";

interface Props {
  className?: string;
}

export const SalesFilter = (props: Props) => {
  const { t } = useTranslation();
  const activeSalesCampaignCodes = useActiveSalesCampaignCodes();

  const isActive = useSelector(selectIsFilterActive);
  const hasCampaignResults = useSelector((state: RootState) => state.srp.results.hasCampaignResults);
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(toggleCampaignOnlyResultsThunk(!isActive));
  };

  if (!activeSalesCampaignCodes.length || !hasCampaignResults) {
    return null;
  }

  return (
    <Root className={props.className}>
      <Switch checked={isActive} onChange={toggle} />
      <span>{t("feature.salesCampaign.searchFilter")}</span>
      <SaleTag size={16} />
    </Root>
  );
};

const Root = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: ICON_MARGIN,
}));
